import React, { useState, useEffect, useRef } from "react";
import "./searchBarWithIcons.scss";
import SearchIcon from "@mui/icons-material/Search";
import closeIcon from "../../../../assets/close.svg";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

const SearchBarWithIcon = ({
  inputCallBack,
  isClearable,
  search_string,
  placeholder,
  disabled,
}) => {
  const currentRef = useRef();
  const [inputValue, setInputValue] = useState("");
  const debouncedSearchTerm = useDebounce(inputValue, 1000);

  useEffect(
    () => {
      if (currentRef.current !== undefined) {
        inputCallBack(inputValue);
      }
      currentRef.current = debouncedSearchTerm;
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  useEffect(() => {
    setInputValue(search_string ? search_string : "");
  }, [search_string]);

  const handleOnChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleClearInput = () => {
    setInputValue("");
    inputCallBack("");
  };

  const renderSearchBar = () => {
    return (
      <div className="search-bar-with-icons-container">
        <div className="search-icon">
          <SearchIcon />
        </div>
        <div className="search-input-container">
          <input
            className="search-input"
            placeholder={placeholder}
            onKeyDown={(e) => e.stopPropagation()}
            value={inputValue}
            onChange={(e) => handleOnChange(e)}
            disabled={disabled}
            autoComplete="new-password"
          />
        </div>
        {inputValue?.length > 0 && isClearable && (
          <div className="search-clear">
            <div className="search-clear-icom" onClick={handleClearInput}>
              <img src={closeIcon} alt="" />
            </div>
          </div>
        )}
      </div>
    );
  };
  return <>{renderSearchBar()}</>;
};

export default SearchBarWithIcon;
